<script>
import { FormDialog } from '@formily/element'
import { NoticeBar } from 'vant'
import ChangePasswordDialogForm from './ChangePassword'
import { getUserInfo, updatePartialInfo } from '@/api/userManage'
import 'vant/es/notice-bar/style'
import { initPoints, points, updatePoints } from '@/store/points'

export default {
  name: 'VcHeader',
  components: {
    NoticeBar,
  },
  setup() {
    // 初始化积分值
    initPoints()
    return {
      points,
    }
  },
  data: () => ({
    roleId: localStorage.getItem('roleId'),
    customerName: localStorage.getItem('customerName'),
    noticeMessage: [],
    systemMessage: '',
    duration: 0,
  }),
  created() {
    this.getNoticeMessage()
    this.getSystemMessage()
    // 刷新积分值
    this.refreshUserPoints()
    setInterval(() => {
      this.getNoticeMessage()
      this.getSystemMessage()
    }, 1000 * 60)
  },
  methods: {
    // 退出登录
    async handleCommand(command) {
      if (command === 'out') {
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push({
          name: 'Login',
        })
      }

      if (command === 'change-password') {
        const formData = await FormDialog('修改密码', ChangePasswordDialogForm).open()
        const res = await updatePartialInfo({
          id: localStorage.getItem('userId'),
          modifyTag: 3,
          passwd: formData.passwd,
        })
        this.$message.success(res.head.msg)
      }
    },
    async getSystemMessage() {
      const res = await this.$post('/insurance/msg/getMsgList', {
        pageNum: 1,
        pageSize: 1,
        msgType: 1,
      })
      this.systemMessage = res.body.result?.msgContent
    },
    async getNoticeMessage() {
      const res = await this.$post('/insurance/msg/getMsgList', {
        pageNum: 1,
        pageSize: 999,
        msgType: 2,
      })
      this.noticeMessage = res.body.result
    },
    async readMessage(item) {
      await this.$post('/insurance/msg/updateMsgStatus', {
        msgIds: [item.id],
      })
      this.noticeMessage.splice(this.noticeMessage.indexOf(item), 1)
    },
    // 刷新用户积分值
    async refreshUserPoints() {
      try {
        const userId = localStorage.getItem('userId')
        if (userId && userId !== '') {
          const res = await getUserInfo(userId)
          // 如果返回的数据中包含积分值，更新它
          if (res.body && res.body.userInfo) {
            const userInfo = res.body.userInfo

            // 1. 更新积分
            const pointsValue = userInfo.points || userInfo.userPoints || 0
            updatePoints(pointsValue)

            // 【新增】：2. 更新权限列表 (menuList) 到 localStorage
            if (userInfo.menuList && Array.isArray(userInfo.menuList)) {
              localStorage.setItem('menuList', JSON.stringify(userInfo.menuList))
              console.log('[Header] 权限列表已更新:', userInfo.menuList)
            }
            else {
              // 如果后端没返 menuList，确保存一个空数组，避免 null 导致解析错误
              localStorage.setItem('menuList', '[]')
            }
          }
        }
      }
      catch (error) {
        console.error('刷新用户信息失败:', error)
      }
    },
  },
}
</script>

<template>
  <ElHeader>
    <div class="system">
      <ElAvatar :src="require('@/assets/logo.png')" class="logo-box" />
      <span class="system-name">万成管理系统</span>
    </div>

    <div v-if="systemMessage">
      <NoticeBar :text="systemMessage" class="w-400px" left-icon="volume-o" scrollable />
    </div>

    <div class="account flex items-center gap-6">
      <span style="font-size: 15px;color: #e5e7eb;">
        您的积分为：{{ points }}
      </span>

      <div>
        <ElPopover
          placement="bottom"
          trigger="click"
          width="400"
        >
          <div v-if="noticeMessage.length" class="flex flex-col gap-3 max-h-400px overflow-y-auto">
            <div v-for="item of noticeMessage" :key="item.id">
              <ElCard :body-style="{ padding: 0 }" shadow="hover">
                <div class="flex p-2 justify-between items-center gap-3">
                  <div>
                    <div>{{ item.msgContent }}</div>
                    <div class="text-xs text-gray-500">
                      {{ item.createTime }}
                    </div>
                  </div>
                  <div>
                    <ElButton size="mini" @click="readMessage(item)">
                      已读
                    </ElButton>
                  </div>
                </div>
              </ElCard>
            </div>
          </div>
          <div v-else class="text-center">
            暂无未读消息
          </div>
          <template #reference>
            <ElBadge :value="noticeMessage.length || ''" class="item">
              <ElButton icon="el-icon-message-solid" size="mini" circle />
            </ElBadge>
          </template>
        </ElPopover>
      </div>

      <ElDropdown @command="handleCommand">
        <span class="account-name">
          {{ roleId === '3' ? '用户' : roleId === '1' ? '系统管理员' : roleId === '5' ? `业务经理-${customerName}` : '管理员' }}<i class="el-icon-arrow-down el-icon--right" />
        </span>
        <template #dropdown>
          <ElDropdownMenu>
            <ElDropdownItem command="change-password">
              修改密码
            </ElDropdownItem>
            <ElDropdownItem class="dropdown-item--danger" command="out">
              退出登录
            </ElDropdownItem>
          </ElDropdownMenu>
        </template>
      </ElDropdown>
    </div>
  </ElHeader>
</template>

<style lang="scss" scoped>
@import "src/styles/element-variables";

.el-header {
  padding: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #e6e6e6;
  background: hsl(197, 51%, 62%);
}

.system {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 240px;
  padding-right: 20px;
  user-select: none;

  .system-name {
    font-weight: bold;
    line-height: 0;
    color: white;
    padding-left: 12px;
  }
  .logo-box{
    width: 35px;
    height: 35px;
    background-size: 35px;
  }
}

.collapse-btn {
  font-size: 24px;
  padding-left: 27px;
  cursor: pointer;
}

.account {
  margin-left: auto;
  padding-right: 20px;

  .account-name {
    cursor: pointer;
    color: #e6e6e6;
  }
}

.dropdown-item--danger {
  color: $--color-danger;

  &:focus,
  &:not(.is-disabled):hover {
    color: $--color-danger;
    background-color: transparentize($--color-danger, 0.9);
  }
}
</style>

<style>
@keyframes scrollText {
  0% {
      transform: translateX(var(--parent-width));
  }
  100% {
      transform: translateX(-100%);
  }
}
</style>
